<template>
  <v-card>
    <v-data-table
      :headers="headers_operazioni"
      :items="items_operazioni.filter((o) => o.validita != 0)"
    >
      <template v-slot:top>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Operazioni </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="addOperazione" small v-bind="attrs" v-on="on">
                <v-icon color="primary"> mdi-plus </v-icon>
              </v-btn>
            </template>
            <span>Aggiungi</span>
          </v-tooltip>

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ml-5"
                @click="setOperazioni"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone per tornare indietro -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="clickIndietro" small v-bind="attrs" v-on="on">
                <v-icon color="error"> mdi-keyboard-backspace </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
      </template>
      <!-- Bottone di selezione dell'operazione -->
      <template v-slot:[`item.abilitazione`]="{ item }">
        <v-btn
          @click="selectOperazione(item)"
          :color="item.abilitazione == 0 ? '' : 'success'"
          icon
        >
          <v-icon>
            {{
              item.abilitazione == 0
                ? "mdi-checkbox-blank-outline"
                : "mdi-checkbox-marked"
            }}
          </v-icon>
        </v-btn>
      </template>

      <!-- Bottone di modifica dell'operazione -->
      <template v-slot:[`item.modifica`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="editOperazione(item)" small v-bind="attrs" v-on="on">
              <v-icon color="primary"> mdi-pencil </v-icon>
            </v-btn>
          </template>
          <span>Modifica</span>
        </v-tooltip>
      </template>

      <!-- Colonna dei pulsanti dell'operazione -->
      <template v-slot:[`item.pulsanti`]="{ item }">
        {{ item.pulsanti ? printTooltips(item.pulsanti) : "" }}
      </template>

      <!-- Bottone di eliminazione dell'operazione -->
      <template v-slot:[`item.elimina`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="clickDeleteOperazione(item)"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="error"> mdi-close </v-icon>
            </v-btn>
          </template>
          <span>Cancella</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <v-dialog v-model="conferma_elimina_operazione" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler cancellare l'operazione selezionata?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="conferma_elimina_operazione = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="deleteOperazione" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <v-overlay :value="overlay_cancellazione">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <v-dialog v-model="dialog_modifica" max-width="800px">
      <ModificaOperazione
        @click_chiudi="dialog_modifica = false"
        :items_btn="items_btn"
        :operazione="operazione_sel"
        :riferimento="riferimento"
        @salvata_operazione="handleSalvataOperazione"
        :tipo_riferimento="tipo_riferimento"
        :visible="dialog_modifica"
      />
    </v-dialog>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import ModificaOperazione from "@/components/OPERAZIONI/ModificaOperazione.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Operazione {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] =
          arg[c.nome] != undefined
            ? c.complex === false
              ? arg[c.nome]
              : JSON.parse(JSON.stringify(arg[c.nome]))
            : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "abilitazione", default_val: 0, complex: false },
      { nome: "cod_operazione", default_val: "", complex: false },
      { nome: "des_operazione", default_val: "", complex: false },
      { nome: "des_tipo", default_val: "", complex: false },
      { nome: "id_operazione", default_val: -1, complex: false },
      { nome: "id_operazione_abilitazione", default_val: -1, complex: false },
      { nome: "pulsanti", default_val: [], complex: true },
      { nome: "query", default_val: "", complex: false },
      { nome: "riferimento", default_val: null, complex: false },
      { nome: "tipo_operazione", default_val: null, complex: false },
      { nome: "tipo_riferimento", default_val: "", complex: false },
      { nome: "validita", default_val: 1, complex: false },
    ];

    return campi;
  }
}

export default {
  name: "TabellaOperazioni",
  components: {
    ModificaOperazione,
    SnackbarQV,
  },
  props: {
    riferimento: { type: Number, default: null },
    tipo_riferimento: { type: String, default: "" },
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      // Variabili d'appoggio
      operazione_sel: new Operazione(),

      // Modal
      conferma_elimina_operazione: false,
      dialog_modifica: false,
      overlay: false,
      overlay_cancellazione: false,

      // Array
      headers_operazioni: [
        { text: "Seleziona", value: "abilitazione", sortable: false },
        { text: "Modifica", value: "modifica", sortable: false },
        { text: "Cod. Operazione", value: "cod_operazione", sortable: false },
        { text: "Des. Operazione", value: "des_operazione", sortable: false },
        { text: "Pulsanti", value: "pulsanti", sortable: false },
        {
          text: "Tipo Operazione",
          value: "des_tipo",
          sortable: false,
        },
        { text: "Elimina", value: "elimina", sortable: false },
      ],
      items_btn: new Array(),
      items_operazioni: new Array(),
    };
  },
  computed: {},
  watch: {
    visible: {
      immediate: true,
      async handler() {
        if (this.visible === true) {
          await this.getPulsantiHeader();
          await this.getOperazioni();
          this.getOperazioniAbilitazioni();
        }
      },
    },
  },
  methods: {
    addOperazione() {
      this.operazione_sel = new Operazione();
      this.operazione_sel.riferimento = this.riferimento;
      this.operazione_sel.tipo_riferimento = this.tipo_riferimento;

      this.dialog_modifica = true;
    },
    clickDeleteOperazione(arg) {
      this.operazione_sel = new Operazione(arg);
      this.conferma_elimina_operazione = true;
    },
    clickIndietro() {
      this.$emit("click_indietro");
    },
    deleteOperazione() {
      /* Se l'operazione era nuova enon l'ho ancora salvata la metto
       * non valida e la data table smetterà automaticamente di mostrarla. */
      if (this.operazione_sel.id_operazione < 0) {
        for (let o = 0; o < this.items_operazioni.length; o++) {
          if (
            this.items_operazioni[o].id_operazione ==
            this.operazione_sel.id_operazione
          ) {
            this.$set(this.items_operazioni[o], "validita", 0);
          }
        }

        this.conferma_elimina_operazione = false;
      } else {
        // Se invece l'operazione esisteva la cancello con una chiamata al BE.
        this.executeCallDeleteOperazione();
      }
    },
    editOperazione(arg) {
      this.operazione_sel = new Operazione(arg);
      this.dialog_modifica = true;
    },
    executeCallDeleteOperazione() {
      const obj_tmp = new Operazione(this.operazione_sel);
      obj_tmp.validita = 0;

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setoperazioni",
          token: localStorage.user_token,
          tabella: [obj_tmp],
        },
      };

      this.overlay_cancellazione = true;

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay_cancellazione = false;
          if (res.status === 200) {
            this.conferma_elimina_operazione = false;
            this.getOperazioni();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i fati."
            );
          }
        })
        .catch((e) => {
          this.overlay_cancellazione = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i fati."
          );
        });
    },
    getOperazioni() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getoperazioni",
          token: localStorage.user_token,
        },
      };

      this.overlay = true;
      return this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.items_operazioni = new Array();
            res.data.result.operazioni.forEach((o) => {
              const obj_tmp = new Operazione(o);
              obj_tmp.riferimento = this.riferimento;
              obj_tmp.tipo_riferimento = this.tipo_riferimento;

              this.items_operazioni.push(obj_tmp);
            });
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            return false;
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          return false;
        });
    },
    getOperazioniAbilitazioni() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getoperazioniabilitazioni",
          token: localStorage.user_token,
          riferimento: this.riferimento,
          tipo_riferimento: this.tipo_riferimento,
        },
      };

      this.overlay = true;

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            res.data.result.autorizzazioni.forEach((a) => {
              this.items_operazioni.forEach((o) => {
                if (o.id_operazione === a.id_operazione) {
                  o.id_operazione_abilitazione = a.id_operazione_abilitazione;
                  o.pulsanti.push({
                    fields: a.fields,
                    des:
                      this.items_btn.filter((p) => p.fields === a.fields)
                        .length > 0
                        ? this.items_btn.filter((p) => p.fields === a.fields)[0]
                            .tooltip
                        : "",
                  });
                  o.abilitazione = 1;
                }
              });
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    getPulsantiHeader() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getpulsantiheader",
          token: localStorage.user_token,
          nome_modulo: "AVANZAMENTO",
          id_profilo: "",
        },
      };

      this.overlay = true;

      return this.$store
        .dispatch("api", request)
        .then((res) => {
          // Se la risposta è in 200...
          if (res.status === 200) {
            // ... Preparo l'array dei bottoni...
            const arr_btn_tmp = new Array();

            // ... Popolo il mio array...
            res.data.forEach((e) => {
              if (e.tipo_oggetto === "B") {
                const obj_tmp = new Object();
                obj_tmp.id_header = e.id_header;
                obj_tmp.fields = e.fields;
                obj_tmp.tooltip = e.tooltip;
                arr_btn_tmp.push(obj_tmp);
              }
            });

            // ... E li registro nelle variabili di supporto del componente.
            this.items_btn = arr_btn_tmp;
            this.overlay = false;
            return true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
            this.overlay = false;
            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );
          this.overlay = false;
          return false;
        });
    },
    async handleSalvataOperazione() {
      this.dialog_modifica = false;

      await this.getOperazioni();
      this.getOperazioniAbilitazioni();
    },
    printTooltips(arg_arr) {
      let res = "";
      arg_arr.forEach((e) => (res += e.tooltip + ", "));
      if (res.length > 0) {
        res = res.substring(0, res.length - 2);
      }
      return res;
    },
    selectOperazione(arg) {
      this.$set(arg, "abilitazione", arg.abilitazione == 1 ? 0 : 1);
    },
    setOperazioni() {
      // Metto da parte le operazioni vecchie e quelle nuove e valide.
      const arr_tmp = JSON.parse(
        JSON.stringify(
          this.items_operazioni.filter(
            (o) => o.validita != 0 || o.id_operazione > 0
          )
        )
      );

      // Metto a -1 l'identificativo delle operazioni nuove.
      arr_tmp.forEach((o) => {
        if (o.id_operaizone < 0) {
          o.id_operazione = -1;
        }
      });

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setoperazioniabilitazioni",
          token: localStorage.user_token,
          tabella: arr_tmp,
        },
      };

      this.overlay = true;

      this.$store
        .dispatch("api", request)
        .then(async (res) => {
          this.overlay = false;
          if (res.status === 200) {
            await this.getOperazioni();
            this.getOperazioniAbilitazioni();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i fati."
            );
          }
        })
        .catch((e) => {
          this.overlay = false;
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i fati."
          );
        });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>